var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 2.16506C18.9517 1.18258 21.0483 1.18258 22.75 2.16506L34.0705 8.70096C35.7722 9.68344 36.8205 11.4991 36.8205 13.4641V26.5359C36.8205 28.5009 35.7722 30.3166 34.0705 31.299L22.75 37.8349C21.0483 38.8174 18.9517 38.8174 17.25 37.8349L5.92949 31.299C4.22779 30.3166 3.17949 28.5009 3.17949 26.5359V13.4641C3.17949 11.4991 4.22779 9.68344 5.92949 8.70096L17.25 2.16506Z",
    fill: "url(#paint0_linear_994_11168)",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 2.16506C18.9517 1.18258 21.0483 1.18258 22.75 2.16506L34.0705 8.70096C35.7722 9.68344 36.8205 11.4991 36.8205 13.4641V26.5359C36.8205 28.5009 35.7722 30.3166 34.0705 31.299L22.75 37.8349C21.0483 38.8174 18.9517 38.8174 17.25 37.8349L5.92949 31.299C4.22779 30.3166 3.17949 28.5009 3.17949 26.5359V13.4641C3.17949 11.4991 4.22779 9.68344 5.92949 8.70096L17.25 2.16506Z",
    stroke: "white",
    style: {
      mixBlendMode: "overlay"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_994_11168)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1958 14.3104C14.4179 15.6021 13.529 16.2479 13.1798 17.202C13.1518 17.2785 13.1266 17.356 13.1043 17.4344C12.826 18.4114 13.1655 19.4564 13.8446 21.5464C14.5237 23.6365 14.8633 24.6815 15.6627 25.3083C15.7268 25.3586 15.7928 25.4065 15.8604 25.452C16.7036 26.0186 17.8024 26.0186 20 26.0186C22.1976 26.0186 23.2964 26.0186 24.1396 25.452C24.2072 25.4065 24.2732 25.3586 24.3373 25.3083C25.1367 24.6815 25.4763 23.6365 26.1554 21.5465C26.8345 19.4564 27.174 18.4114 26.8957 17.4344C26.8734 17.356 26.8482 17.2785 26.8202 17.202C26.471 16.2479 25.5821 15.6021 23.8042 14.3104C22.0264 13.0187 21.1374 12.3728 20.1222 12.3356C20.0408 12.3326 19.9592 12.3326 19.8778 12.3356C18.8626 12.3728 17.9737 13.0187 16.1958 14.3104ZM18.6667 22.3798C18.3905 22.3798 18.1667 22.6036 18.1667 22.8798C18.1667 23.1559 18.3905 23.3798 18.6667 23.3798H21.3333C21.6095 23.3798 21.8333 23.1559 21.8333 22.8798C21.8333 22.6036 21.6095 22.3798 21.3333 22.3798H18.6667Z",
    fill: "url(#paint1_linear_994_11168)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_994_11168",
    x1: 18.0556,
    y1: 21.1111,
    x2: 6.94445,
    y2: 33.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C441F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DAEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_994_11168",
    x1: 20,
    y1: 25,
    x2: 20.0004,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4CBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999496,
    stopColor: "#F5ECFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_994_11168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.f3a224994444420ce51a51ca585446f3.svg";
export { ForwardRef as ReactComponent };